<template>
  <div class="work-process-mobile">
    <div
      v-for="(p, index) in WORK_PROCESSES"
      :key="index"
      class="work-process-mobile__item process-item"
    >
      <h4 class="process-item__title">{{ p.title }}</h4>
      <span class="process-item__main-text">{{ p.mainText }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { WORK_PROCESSES } from '../consts'

export default defineComponent({
  name: 'WorkProcesses',
  setup() {
    return { WORK_PROCESSES }
  },
})
</script>

<style lang="scss" scoped src="./MobileRender.scss" />
